import React, { useEffect } from "react";
import ErrorScreen from "../../../common/responsive-components/ErrorScreen";
import { isRmJourney } from "../../../group_insurance/products/group_health/common_data";
import { getConfig, navigate as navigateFunc } from "../../../utils/functions";
import { nativeCallback } from "../../../utils/native_callback";
import { storageService } from "../../../utils/validators";
import { logout } from "../../functions";
import { persistor } from "../../../dataLayer/store";
import { useDispatch } from "react-redux";
import { resetStoreData } from "../../../dataLayer/reducers";
import moengage from "@moengage/web-sdk";
import { isFunction } from "lodash-es";

const config = getConfig();
const Logout = (props) => {
  const navigate = navigateFunc.bind(props);
  const isRM = isRmJourney();
  const dispatch = useDispatch();
  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    dispatch(resetStoreData());
    persistor.purge();
    storageService().remove("persist:root");
    if (window.clevertap) {
      if (isFunction(window.clevertap.logout)) {
        window.clevertap.logout();
      }
      window.clevertap.profile = [];
    }
    moengage.destroy_session();
    if (config.Web) {
      storageService().clear();
      if (config.isIframe) {
        let message = JSON.stringify({
          type: "iframe_close",
        });
        window.callbackWeb.sendEvent(message);
        return;
      }
      try {
        if (!isRM) {
          await logout();
        }
      } catch (err) {
        console.log(err);
      } finally {
        if (isRM) {
          navigate("/rm-login");
        } else if (config.code === "ubiweb") {
          window.location.href = `https://www.unionbankonline.co.in/`;
        } else {
          setTimeout(
            () =>
              navigate("/login", {
                searchParams: `base_url=${config.base_url}`,
              }),
            2000
          );
        }
      }
    } else {
      nativeCallback({ action: "session_expired" });
    }
  };

  return (
    <ErrorScreen
      useTemplate
      templateErrTitle="You have been logged out."
      templateErrText="Redirecting to login page..."
    />
  );
};

export default Logout;
